import { render, staticRenderFns } from "./AddressUpload.vue?vue&type=template&id=2224db34&"
import script from "./AddressUpload.vue?vue&type=script&lang=ts&"
export * from "./AddressUpload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports